import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";

const SOURCE_OPTIONS = [
    "google", "linkedin", "x", "youtube", "instagram",
    "facebook", "reddit", "newsletter", "podcast",
    "friends", "ai", "other",
];

function CreateWorkspaceStep2({ source, setSource, onContinue, onSkip, onBack, isLoading }) {
    const { t } = useTranslation();

    return (
        <div className="flex-1 flex flex-col p-8 sm:p-12">
            <button onClick={onBack} className="flex items-center text-gray-400 hover:text-gray-600 mb-8 self-start">
                <ChevronLeft size={20} />
            </button>
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">
                {t("sidebar.workspace.step2Title")}
            </h1>
            <p className="text-sm text-gray-500 mb-8">
                {t("sidebar.workspace.step2Description")}
            </p>
            <div className="flex flex-wrap gap-2 mb-auto">
                {SOURCE_OPTIONS.map((key) => (
                    <button
                        key={key}
                        type="button"
                        onClick={() => setSource(source === key ? "" : key)}
                        className={`px-4 py-2 rounded-full text-sm border transition-colors ${
                            source === key
                                ? "border-blue-600 bg-blue-50 text-blue-700"
                                : "border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                        }`}
                    >
                        {t(`sidebar.workspace.sources.${key}`)}
                    </button>
                ))}
            </div>
            <button
                onClick={onContinue}
                disabled={isLoading}
                className="w-full mt-8 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:opacity-50"
            >
                {isLoading ? t("common.creating") : t("sidebar.workspace.continue")}
            </button>
            <button
                onClick={onSkip}
                disabled={isLoading}
                className="w-full mt-2 py-2 text-sm text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50"
            >
                {t("sidebar.workspace.skip")}
            </button>
        </div>
    );
}

export default CreateWorkspaceStep2;
